import API from "./api.service";
const apiCall = API.Create();
export default apiCall;
